<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="flex flex-col items-center justify-center mb-4 sm:mb-8 max-w-2xl">
    <h1 class="text-2xl font-bold mb-2 text-center">
      {{ t('error_screen.shop_reset_failed.title') }}
    </h1>
    <ol class="list-decimal list-inside text-center text-sm mb-4">
      <li>
        {{ t('error_screen.shop_reset_failed.step_1') }}
      </li>
      <li>
        {{ t('error_screen.shop_reset_failed.step_2') }}
      </li>
      <i18n-t keypath="error_screen.shop_reset_failed.step_3" tag="li">
        <template #marketplace>
          <PuikLink :href="t('error_screen.shop_reset_failed.mbo_link_on_addons')">{{
            t('error_screen.shop_reset_failed.marketplace')
          }}</PuikLink>
        </template>
      </i18n-t>
    </ol>
    <i18n-t
      keypath="error_screen.shop_reset_failed.problem_persists"
      tag="p"
      class="text-center text-sm"
    >
      <template #help_center_form_link>
        <PuikLink :href="t('error_screen.shop_reset_failed.help_center_form_link')">{{
          t('error_screen.shop_reset_failed.help_center_form_link')
        }}</PuikLink>
      </template>
    </i18n-t>
  </div>
</template>
